import React from 'react'
import './newtonCradleLoader.css'

const NewtonCradleLoader = ({
  className = '',
  label,
  message,
  messageColor,
  size = 'md',
  style
}) => {
  const accessibleLabel = label || message || 'Loading'
  const loaderClassName = [
    'newton-cradle-loader',
    `newton-cradle-loader--${size}`,
    className
  ].filter(Boolean).join(' ')

  return (
    <span
      aria-busy='true'
      aria-label={accessibleLabel}
      className={loaderClassName}
      role='status'
      style={style}
    >
      <span aria-hidden='true' className='newton-cradle-loader__balls'>
        <span className='newton-cradle-loader__ball newton-cradle-loader__ball--left' />
        <span className='newton-cradle-loader__ball' />
        <span className='newton-cradle-loader__ball' />
        <span className='newton-cradle-loader__ball' />
        <span className='newton-cradle-loader__ball newton-cradle-loader__ball--right' />
      </span>
      {message ? <span className='newton-cradle-loader__message' style={{color: messageColor}}>{message}</span> : null}
    </span>
  )
}

export default NewtonCradleLoader
